import React from "react";

type IInput = {
  value: string;
  placeholder?: string;
};

const AppInput: React.FC<IInput & React.ComponentProps<"input">> = ({
  value,
  onChange,
  ...other
}) => {
  return (
    <input
      className="form-control hl-input"
      value={value}
      onChange={onChange}
      {...other}
    />
  );
};

export default AppInput;
